import type { InjectionKey, Ref } from 'vue'
import type { IntakeAddress, IntakeAddressSuggestion } from '@/api/schemas'

/**
 * Address suggestions for AddressFields. The intake page provides one bound to
 * its link token once the server says a lookup is configured; while the ref is
 * empty the address fields are plain inputs.
 */
export interface AddressLookup {
  suggest: (
    query: string,
    session: string,
    signal: AbortSignal,
  ) => Promise<IntakeAddressSuggestion[]>
  resolve: (placeId: string, session: string) => Promise<IntakeAddress>
}

export const addressLookupKey: InjectionKey<Readonly<Ref<AddressLookup | undefined>>> =
  Symbol('addressLookup')

/**
 * A session token groups one address's typing and its final pick, which Google
 * bills as one lookup. getRandomValues works on plain-http dev hosts, where
 * crypto.randomUUID does not.
 */
export function newLookupSession(): string {
  const bytes = crypto.getRandomValues(new Uint8Array(16))
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('')
}
